import __request__ from "routing/request";
export function views(sort = "title", page = 1, per_page = 50, order = "asc", query, filters, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/search/saved", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query, "filters": filters }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
